import { Box, Drawer, Paper, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import MinimizeIcon from "@mui/icons-material/Minimize";
import { Close } from "@mui/icons-material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import globalDrawerStyles from "./globalDrawerStyles";
import { useDrawer } from "../../provider/DrawerProvider";

type GlobalDrawerProps = {
  drawerTitle: string;
  setDrawerContentNode: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
  setDrawerActionsNode: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
  setDrawerHeaderNode: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
};

export default function GlobalDrawer({
  drawerTitle,
  setDrawerContentNode,
  setDrawerActionsNode,
  setDrawerHeaderNode,
}: GlobalDrawerProps) {
  const { closeDrawer, drawerState } = useDrawer();

  const [isMaximized, setIsMaximized] = useState(true);

  if (!drawerState?.type) {
    return null;
  }

  return (
    <>
      {!isMaximized && (
        <Stack sx={globalDrawerStyles.stackDrawer} direction={"row"}>
          <Paper>
            <Stack direction={"row"} sx={{ alignItems: "center" }}>
              <Typography variant="h5" sx={globalDrawerStyles.stackDrawerBox}>
                {drawerTitle}
              </Typography>
              <Box sx={globalDrawerStyles.boxIcon}>
                <IconButton onClick={() => setIsMaximized(true)} size="medium">
                  <OpenInFullIcon />
                </IconButton>
                <IconButton onClick={closeDrawer} size="medium">
                  <Close />
                </IconButton>
              </Box>
            </Stack>
          </Paper>
        </Stack>
      )}
      <Drawer
        open={isMaximized}
        anchor={"bottom"}
        slotProps={{
          paper: {
            elevation: 16,
            sx: [
              globalDrawerStyles.drawerPaper,
              drawerState.highlighted ? globalDrawerStyles.highlighted : null,
              drawerState.wide ? globalDrawerStyles.widePaper : null,
            ],
          },
        }}
        ModalProps={{
          keepMounted: true,
        }}
        variant="persistent"
      >
        <Stack sx={globalDrawerStyles.drawerContentStack}>
          <Stack
            sx={{
              ...globalDrawerStyles.drawerHeaderStack,
              alignItems: "center",
            }}
            direction={"row"}
          >
            <Typography variant="h5" sx={globalDrawerStyles.drawerTitleBox}>
              {drawerTitle}
            </Typography>
            <Box ref={setDrawerHeaderNode} sx={{ display: "flex", alignItems: "center", flexShrink: 0 }} />
            <Box sx={globalDrawerStyles.boxIcon}>
              <IconButton onClick={() => setIsMaximized(false)} size="medium">
                <MinimizeIcon />
              </IconButton>
              <IconButton onClick={closeDrawer} size="medium">
                <Close />
              </IconButton>
            </Box>
          </Stack>
          <Stack sx={globalDrawerStyles.drawerContent}>
            <Box ref={setDrawerContentNode} sx={drawerState.wide ? { width: "100%" } : null} />
          </Stack>
          <Stack
            sx={{
              ...globalDrawerStyles.drawerActions,
              alignItems: "center",
              justifyContent: "center",
            }}
            direction={"row"}
            ref={setDrawerActionsNode}
          />
        </Stack>
      </Drawer>
    </>
  );
}
